<div class="new-item-modal">
  <h3 class="mat-h3">Preview {{ data.filename }}</h3>

  <div class="component-container">
    <ng-template #dynamicContainer></ng-template>
  </div>

  <div class="d-flex align-items-center justify-content-between m-t-16">
    <button
      (click)="cancel()"
      color="accent"
      mat-raised-button>
      Cancel
    </button>
  </div>
</div>
